import {faker}  from "@faker-js/faker";
import { regions } from "./regions";
import { getOrgApp } from "../helpers/get-orgApp";
import { ecsClusterResources } from "./resources";

const tagKeyValues = [
  {
    Key: "untagged-resources",
    Value: "-",
    ResourceCount: "89",
  },
  {
    Key: "Cost Center",
    Value: "Research Computing",
    ResourceCount: "26",
  },
  {
    Key: "Compliance",
    Value: "HIPAA",
  },
  {
    Key: "Compliance",
    Value: "PCI",
  },
  {
    Key: "Data Sensitivity",
    Value: "4",
  },
  {
    Key: "Cost Center",
    Value: "51003",
  },
  {
    Key: "Owner",
    Value: "Cloud Admin",
  },
  {
    Key: "Data Sensitivity",
    Value: "5",
  },
  {
    Key: "Owner",
    Value: "HR Department Admin",
  },
  {
    Key: "Purpose",
    Value: "Demo",
  },
  {
    Key: "Purpose",
    Value: "Test",
  },
  {
    Key: "ServerGroup",
    Value: "Hr-Prod",
  },
  {
    Key: "Sensitivity Rating",
    Value: "5",
  },
];

export const getAllTags = async () => {
  let tags = [];
  let orgAppDetails = await getOrgApp();
  for (var i = 0; i < tagKeyValues.length; i++) {
    let selectedOrg = faker.helpers.arrayElement(orgAppDetails);
    let selectedDept = faker.helpers.arrayElement(selectedOrg.depts);
    tags.push({
      Key: tagKeyValues[i].Key,
      Value: tagKeyValues[i].Value,
      ResourceType: "Tags",
      RegionCode: faker.helpers.arrayElement(regions).RegionCode,
      OrganizationId: selectedOrg.orgId,
      DepartmentId: selectedDept.deptId,
      ResourceCount: tagKeyValues[i].ResourceCount
        ? tagKeyValues[i].ResourceCount
        : faker.number.int({ min: 10, max: 300 }),
    });
  }
  return tags;
};

export const getResourcesforTags = (selectedTag, resources) => {
  let tagResources = [];
  if (
    selectedTag.Key === "Cost Center" &&
    selectedTag.Value === "Research Computing"
  ) {
    tagResources = ecsClusterResources();
  } else {
    let filteredResources = [];
    filteredResources = resources.filter(
      (res) => res.DepartmentId === selectedTag.DepartmentId
    );
    const selected = filteredResources.slice(0, selectedTag.ResourceCount);
    selected.forEach((res) => {
      let resource = { ...res };
      tagResources.push(resource);
    });
  }

  return tagResources;
};
